import * as z from 'zod';
export const ReservationSources = z.enum(['unknown', 'reservations_app', 'camping_online_app', 'addons_app']);
